<template>
	<button
		class="d-flex align-center cursor-pointer px-3"
		:class="`chip-${size}`"
		:style="{ borderRadius: radius }"
	>
		<span :class="textSize">
			<slot />
		</span>
	</button>
</template>

<script setup lang="ts">
	import { computed } from 'vue'

	interface Props {
		size?: 'xs' | 's' | 'm' | 'l'
		radius?: string
	}

	const textSize = computed(() => {
		const list = {
			xs: 'text-label-s',
			s: 'text-label-m',
			m: 'text-label-m',
			l: 'text-label-m',
		}
		return list[props.size]
	})

	const props = withDefaults(defineProps<Props>(), {
		size: 'm',
		radius: '999px',
	})
</script>

<style scoped lang="scss">
	.chip-l {
		height: 48px;
	}
	.chip-m {
		height: 40px;
	}
	.chip-s {
		height: 32px;
	}
	.chip-xs {
		height: 24px;
	}
</style>
